import React, { useEffect, useState } from 'react';
import {
  statisticsNFTCarExcelDataRequest,
  statisticsNFTCarListRequest, statisticsNFTLevelExcelDataRequest,
  statisticsNFTLevelStatListRequest, statisticsNFTStatExcelDataRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import { CALCULATE_EMPTY_DATE, DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import { useDispatch } from 'react-redux';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { nftGrade, nftType } from '../../../../constants/nft';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import BtnIcons from '../../../../api/images/btnIcons';
import SimpleComposedChart from '../ChartComponents/SimpleComposedChart';
import Notification from '../../../../components/Notification/Notification';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import FetchLoading from "../../../../components/Loading/FetchLoading";
import DataItem from "../DataItem";
import useSchemaMonitoringNftLevel from "../../../../schema/table-schema/useSchemaMonitoringNftLevel";
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringNftCarDataStat from "../../../../schema/table-schema/useSchemaMonitoringNftCarDataStat";
import {
  SearchBtn,
  SearchBtnContainer,
  SearchContainer, SearchContent,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";
import useSchemaMonitoringNftCarDataLevel from "../../../../schema/table-schema/useSchemaMonitoringNftCarDataLevel";

function car() {
  // -- component const --//
  // 인장
  const VehicleSeals = [
    { value: '', label: '전체' },
    { value: 'None', label: 'None' },
    { value: 'Genesis', label: 'Genesis' },
    { value: 'Evolved', label: 'Evolved' },
  ];

  // 플러스여부
  const IsPlus = [
    { value: null, label: '전체' },
    { value: true, label: 'O' },
    { value: false, label: 'X' },
  ];

  // 차종
  const nftTypes = Object.keys(nftType).map(key => ({
    key: nftType[key],
    value: key,
  }));

  // 차량 등급
  const nftGrades = Object.keys(nftGrade).map(key => ({
    key: nftGrade[key],
    value: key.toString(),
  }));

  const tHead = {
    "level": [
      '날짜', '1~100', '101~200', '201~300', '301~400', '401~500',
      '501~600', '601~700', '701~800', '801~900', '901~1000', '1001이상',
    ],
    "stat": [
      '날짜', '1~1000', '1001~2000', '2001~3000', '3001~4000', '4001~5000',
      '5001~6000', '6001~7000', '7001~8000', '8001~9000', '9001~10000', '10001이상',
    ],
  };

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeLevel, setActiveDateRangeLevel] = useState(7);
  const [activeDateRangeTotal, setActiveDateRangeTotal] = useState(7);

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [vehicleSealTable, setVehicleSealTable] = useState('');
  const [isPlusTable, setIsPlusTable] = useState(null);
  const [NFTGradeTable, setNFTGradesTable] = useState([]);
  const [NFTTypeTable, setNFTTypesTable] = useState([]);
  const [needNftTypeTable, setNeedNftTypeTable] = useState(15);

  const [data, setData] = useState([{}]);
  const [lineData, setLineData] = useState([{}]);

  const [tableType, setTableType] = useState('level');
  const [tableContextType, setTableContextType] = useState('level');

  const [vehicleSeal, setVehicleSeal] = useState('');
  const [isPlus, setIsPlus] = useState(null);
  const [NFTGrade, setNFTGrades] = useState([]);
  const [NFTType, setNFTTypes] = useState([]);
  const [needNftType, setNeedNftType] = useState(15);

  const [startAtLevel, setStartAtLevel] = useState(DAYS_AGO(activeDateRangeLevel));
  const [endAtLevel, setEndAtLevel] = useState(DAYS_AGO(1));

  const [startAtTotal, setStartAtTotal] = useState(DAYS_AGO(activeDateRangeTotal));
  const [endAtTotal, setEndAtTotal] = useState(DAYS_AGO(1));

  const [carLevelDistribution, setCarLevelDistribution] = useState([]);
  const [totalCarLevelDistribution, setTotalCarLevelDistribution] = useState([]);
  const [totalCarStatsDistribution, setTotalCarStatsDistribution] = useState([]);

  const levelSchema = useSchemaMonitoringNftCarDataLevel();
  const statSchema = useSchemaMonitoringNftCarDataStat();
  // const [dataSchema, setDataSchema] = useState(levelSchema);

  const [tBody, setTbody] = useState([]);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);

  // Excel Data
  const [excelData, setExcelData] = useState();
  const [excelTotalData, setExcelTotalData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    // const {
    //   target: { value },
    // } = event;

    // 전체 선택시 빈값으로 대치
    const value = event.target.value.includes('')
      ? ['']
      : event.target.value;

    if (type === 'grade') {
      setNFTGrades(value);
    } else if (type === 'type') {
      setNFTTypes(value);
    } else if (type === 'grade-table') {
      setNFTGradesTable(value);
    } else if (type === 'type-table') {
      setNFTTypesTable(value);
    }
  };

  const fetchList = (type) => {

    if (type === 'graph') {
      setIsLoadingGraph(true);

      dispatch(
        statisticsNFTLevelStatListRequest({
          beginDate: startAtLevel,
          endDate: endAtLevel,
          callback: (data) => {
            console.log('요청 결과: ', data);

            // carLevelDistribution 업데이트
            // setCarLevelDistribution(data?.list.map(item => (
            //   item.carLevelDistribution
            // )));

            const filteredData = data?.list.filter(item => item.carLevelDistribution.length > 0);
            setCarLevelDistribution(filteredData.map(item => (
              item.carLevelDistribution
            )));

            setIsLoadingGraph(false);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);

            setIsLoadingGraph(false);
          },
        })
      );

      // 차량 분포 엑셀 데이터 조회
      dispatch(
        statisticsNFTCarExcelDataRequest({
          beginDate: startAtLevel,
          endDate: endAtLevel,
          callback: (data) => {
            console.log('요청 결과: ', data);
            setExcelData(data?.list);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);
          }
        })
      );

    } else if (type === 'table') {
      setTableContextType(tableType);
      setIsLoadingTable(true);

      dispatch(
        statisticsNFTLevelStatListRequest({
          beginDate: startAtTotal,
          endDate: endAtTotal,
          callback: (data) => {
            console.log('요청 결과: ', data);

            if (tableType === 'stat') {

              // totalCarStatsDistribution 업데이트
              // setTotalCarStatsDistribution(data?.list.map(item => (
              //   item.totalCarStatsDistribution
              // )));

              const filteredData = data?.list.filter(item => item.totalCarStatsDistribution.length > 0);
              setTotalCarStatsDistribution(filteredData.map(item => (
                item.totalCarStatsDistribution
              )));

              setTotalCarLevelDistribution([]);

              setIsLoadingTable(false);
              return;
            }

            // totalCarLevelDistribution 업데이트
            // setTotalCarLevelDistribution(data?.list.map(item => (
            //   item.totalCarLevelDistribution
            // )));

            const filteredData = data?.list.filter(item => item.totalCarLevelDistribution.length > 0);
            setTotalCarLevelDistribution(filteredData.map(item => (
              item.totalCarLevelDistribution
            )));

            setTotalCarStatsDistribution([]);

            setIsLoadingTable(false);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);

            setIsLoadingTable(false);
          },
        })
      );

      if (tableType === 'level') {
        dispatch(
          statisticsNFTLevelExcelDataRequest({
            beginDate: startAtTotal,
            endDate: endAtTotal,
            callback: (data) => {
              console.log('요청 결과: ', data);
              setExcelTotalData(data?.list);
            },
            error: (e) => {
              console.log(e);
              setNotificationMessage(e.toString());
              setShowNotification(true);
            },
          })
        );
      }

      if (tableType === 'stat') {
        dispatch(
          statisticsNFTStatExcelDataRequest({
            beginDate: startAtTotal,
            endDate: endAtTotal,
            callback: (data) => {
              console.log('요청 결과: ', data);
              setExcelTotalData(data?.list);
            },
            error: (e) => {
              console.log(e);
              setNotificationMessage(e.toString());
              setShowNotification(true);
            },
          })
        );
      }

    }

  };

  const handleClickDownload = (type) => {
    // 파일 명 설정
    const fileName = type === 'statLevel'
      ? (
        tableType === 'level'
          ? `NFT_차량_LEVEL_합산_${startAtTotal}_${endAtTotal}`
          : `NFT_차량_STAT_합산_${startAtTotal}_${endAtTotal}`
      )
      : `NFT_차량_현황_분포_${startAtLevel}_${endAtLevel}`;

    excelDownload(
      fileName,
      type === 'statLevel' ? excelTotalData : excelData,
      type === 'statLevel'
        ? (
          tableType === 'level'
            ? sortKey.statistics.nft_carLevel
            : sortKey.statistics.nft_carStat
        )
        : sortKey.statistics.nft_car
    );
  };

  // -- react hooks --//
  useEffect(() => {
    setStartAtLevel(DAYS_AGO(activeDateRangeLevel));
    setEndAtLevel(DAYS_AGO(1))
  }, [activeDateRangeLevel]);

  useEffect(() => {
    setStartAtTotal(DAYS_AGO(activeDateRangeTotal));
    setEndAtTotal(DAYS_AGO(1))
  }, [activeDateRangeTotal]);


  useEffect(() => {
    fetchList('table');

    setIsLoading(true);
    setIsLoadingGraph(true);

    dispatch(
      statisticsNFTCarListRequest({
        nftType: Number(needNftTypeTable),
        nftGrade: NFTGradeTable.map(item => String(item)).join(','),
        nftSeal: vehicleSealTable,
        isPlus: isPlusTable,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );

    // 차량 분포 엑셀 데이터 조회
    dispatch(
      statisticsNFTCarExcelDataRequest({
        beginDate: startAtLevel,
        endDate: endAtLevel,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setExcelData(data?.list);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        }
      })
    );

    dispatch(
      statisticsNFTLevelStatListRequest({
        beginDate: startAtLevel,
        endDate: endAtLevel,
        callback: (data) => {
          console.log('요청 결과: ', data);

          // carLevelDistribution 업데이트
          // setCarLevelDistribution(data?.list.map(item => (
          //   item.carLevelDistribution
          // )));

          const filteredData = data?.list.filter(item => item.carLevelDistribution.length > 0);
          setCarLevelDistribution(filteredData.map(item => (
            item.carLevelDistribution
          )));

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );
  }, []);

  useEffect(() => {
    // 조건에 따른 현황 조회
    setIsLoading(true);

    dispatch(
      statisticsNFTCarListRequest({
        nftType: Number(needNftTypeTable),
        nftGrade: NFTGradeTable.map(item => String(item)).join(','),
        nftSeal: vehicleSealTable,
        isPlus: isPlusTable,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [needNftTypeTable, NFTGradeTable, vehicleSealTable, isPlusTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = carLevelDistribution.map((dataArray, index) => {
      if (dataArray.length === 0) {
        return {
          '1~10 레벨': 0,
          '11~20 레벨': 0,
          '21~30 레벨': 0,
          '31~40 레벨': 0,
          '41 레벨 이상': 0,
          '총 스펜딩 수': 0,
          time: CALCULATE_EMPTY_DATE(startAtLevel, index),
        };
      }

      const newDate = dataArray[0].timestamp; // Access timestamp from the first element of the array

      // Aggregate values based on conditions
      const level1_10 = dataArray.find(item => item.tagName === '0')?.value || 0;
      const level11_20 = dataArray.find(item => item.tagName === '10')?.value || 0;
      const level21_30 = dataArray.find(item => item.tagName === '20')?.value || 0;
      const level31_40 = dataArray.find(item => item.tagName === '30')?.value || 0;
      const level41_50 = dataArray.find(item => item.tagName === '40')?.value || 0;

      const totalValue = dataArray.reduce((sum, item) => sum + item.value, 0);

      return {
        '1~10 레벨': level1_10,
        '11~20 레벨': level11_20,
        '21~30 레벨': level21_30,
        '31~40 레벨': level31_40,
        '41 레벨 이상': level41_50,
        '총 스펜딩 수': totalValue,
        time: timeFormAPI.changeDataDate(newDate),
      };
    });

    console.log("carLevelDistribution: ", carLevelDistribution);
    console.log("lineData: ", updateData);
    setLineData(updateData)
  }, [carLevelDistribution]);

  useEffect(() => {
    const updateData = strData && strData.map(data => {
      // 스펜딩 현황
      const totalIssuedCount = data?.totalIssuedCount || 0;
      const totalSpendingCount = data?.totalSpendingCount || 0;
      const totalHolderCount = data?.totalHolderCount || 0;
      const averageHolderCount = (totalSpendingCount / totalHolderCount) || 0;

      const walletToSpendingCount = data?.walletToSpendingCount || 0;
      const spendingToWalletCount = data?.spendingToWalletCount || 0;
      const breedingCount = data?.breedingCount || 0;
      const evolveCount = data?.evolveCount || 0;
      const evolveBurnCount = data?.evolveBurnCount || 0;

      const targetDate = data?.targetDate;

      return {
        totalIssuedCount: totalIssuedCount,
        totalSpendingCount: totalSpendingCount,
        averageHolderCount: averageHolderCount.toFixed(2),
        walletToSpendingCount: walletToSpendingCount,
        spendingToWalletCount: spendingToWalletCount,
        breedingCount: breedingCount,
        evolveCount: evolveCount,
        evolveBurnCount: evolveBurnCount,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);
  }, [strData]);

  useEffect(() => {
    let nftType = 0;
    for (let i = 0; i < NFTType.length; i += 1) {
      nftType |= 1 << NFTType[i];
    }

    setNeedNftType(nftType === 0 ? 15 : nftType);
  }, [NFTType]);

  useEffect(() => {
    let nftType = 0;
    for (let i = 0; i < NFTTypeTable.length; i += 1) {
      nftType |= 1 << NFTTypeTable[i];
    }

    setNeedNftTypeTable(nftType === 0 ? 15 : nftType);
  }, [NFTTypeTable]);

  useEffect(() => {
    let updateData = [];

    if (totalCarLevelDistribution.length > 0) {
      updateData = totalCarLevelDistribution.length > 1 && totalCarLevelDistribution.map((dataArray, index) => {

        if (dataArray.length === 0) {
          return {
            '01': 0,
            '10': 0,
            '20': 0,
            '30': 0,
            '40': 0,
            '50': 0,
            '60': 0,
            '70': 0,
            '80': 0,
            '90': 0,
            'over': 0,
            time: CALCULATE_EMPTY_DATE(startAtTotal, index),
          };
        }

        const newDate = dataArray[0].timestamp; // Access timestamp from the first element of the array

        // Aggregate values based on conditions
        const level1_100 = dataArray.find(item => item.tagName === "0 - 100")?.value || 0;
        const level101_200 = dataArray.find(item => item.tagName === "100 - 200")?.value || 0;
        const level201_300 = dataArray.find(item => item.tagName === "200 - 300")?.value || 0;
        const level301_400 = dataArray.find(item => item.tagName === "300 - 400")?.value || 0;
        const level401_500 = dataArray.find(item => item.tagName === "400 - 500")?.value || 0;
        const level501_600 = dataArray.find(item => item.tagName === "500 - 600")?.value || 0;
        const level601_700 = dataArray.find(item => item.tagName === "600 - 700")?.value || 0;
        const level701_800 = dataArray.find(item => item.tagName === "700 - 800")?.value || 0;
        const level801_900 = dataArray.find(item => item.tagName === "800 - 900")?.value || 0;
        const level901_1000 = dataArray.find(item => item.tagName === "900 - 1000")?.value || 0;
        const over1001 = dataArray.find(item => item.tagName === "1000 ~")?.value || 0;

        return {
          '01': level1_100,
          '10': level101_200,
          '20': level201_300,
          '30': level301_400,
          '40': level401_500,
          '50': level501_600,
          '60': level601_700,
          '70': level701_800,
          '80': level801_900,
          '90': level901_1000,
          'over': over1001,
          time: timeFormAPI.changeDataDate(newDate),
        };
      });

    }

    if (totalCarStatsDistribution.length > 0) {
      updateData = totalCarStatsDistribution.length > 1 && totalCarStatsDistribution.map((dataArray, index) => {

        if (dataArray.length === 0) {
          return {
            '01': 0,
            '10': 0,
            '20': 0,
            '30': 0,
            '40': 0,
            '50': 0,
            '60': 0,
            '70': 0,
            '80': 0,
            '90': 0,
            'over': 0,
            time: CALCULATE_EMPTY_DATE(startAtTotal, index),
          };
        }

        const newDate = dataArray[0].timestamp; // Access timestamp from the first element of the array

        // Aggregate values based on conditions
        const level1_100 = dataArray.find(item => item.tagName === "0 - 1000")?.value || 0;
        const level101_200 = dataArray.find(item => item.tagName === "1000 - 2000")?.value || 0;
        const level201_300 = dataArray.find(item => item.tagName === "2000 - 3000")?.value || 0;
        const level301_400 = dataArray.find(item => item.tagName === "3000 - 4000")?.value || 0;
        const level401_500 = dataArray.find(item => item.tagName === "4000 - 5000")?.value || 0;
        const level501_600 = dataArray.find(item => item.tagName === "5000 - 6000")?.value || 0;
        const level601_700 = dataArray.find(item => item.tagName === "6000 - 7000")?.value || 0;
        const level701_800 = dataArray.find(item => item.tagName === "7000 - 8000")?.value || 0;
        const level801_900 = dataArray.find(item => item.tagName === "8000 - 9000")?.value || 0;
        const level901_1000 = dataArray.find(item => item.tagName === "9000 - 10000")?.value || 0;
        const over1001 = dataArray.find(item => item.tagName === "10000 ~")?.value || 0;

        return {
          '01': level1_100,
          '10': level101_200,
          '20': level201_300,
          '30': level301_400,
          '40': level401_500,
          '50': level501_600,
          '60': level601_700,
          '70': level701_800,
          '80': level801_900,
          '90': level901_1000,
          'over': over1001,
          time: timeFormAPI.changeDataDate(newDate),
        };
      });
    }

    setTbody(updateData);

  }, [totalCarLevelDistribution, totalCarStatsDistribution]);

  // useEffect(() => {
  //
  //
  //   switch (tableContextType){
  //     case false :
  //     case "stat" :
  //       setDataSchema(statSchema);
  //       return;
  //     case "level":
  //     default:
  //       setDataSchema(levelSchema);
  //       return;
  //   }
  //
  // }, [tableContextType]);

  // -- render --//
  return (
    <div>
      <div className="contentsArea">
        <div className="rowDiv">
          <div className="leftDiv" style={{ width: '100%' }}>
            <div className={'contentTitle'}>
              스펜딩 현황 {`(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)`}
            </div>
          </div>

          <div className="rightDiv" style={{ justifyContent: 'flex-end' }}>
            <FormControl id={'formController'}>
              <Select
                displayEmpty
                multiple
                value={NFTTypeTable}
                onChange={(event) => handleChange(event, 'type-table')}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <div style={{ color: '#999' }}>차종</div>;
                  }

                  return selected
                    .map(
                      (value) =>
                        nftTypes.find((item) => item.value === value)?.key,
                    )
                    .filter(Boolean)
                    .join(', ');
                }}
                style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{ padding: '10px', gap: 4 }}>
                  <input
                    type="checkbox"
                    checked={NFTTypeTable.length === nftTypes.length}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      setNFTTypesTable(
                        checked ? nftTypes.map((item) => item.value) : [],
                      );
                    }}
                  />
                  <ListItemText primary="전체 선택" />
                </MenuItem>
                {nftTypes.map((item) => (
                  <MenuItem
                    key={item.value}
                    value={item.value}
                    style={{ padding: '10px', gap: 4 }}
                  >
                    <input
                      type="checkbox"
                      checked={NFTTypeTable.includes(item.value)}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTTypesTable((prevNFTTypesTable) => {
                          if (checked) {
                            return [...prevNFTTypesTable, item.value];
                          } else {
                            return prevNFTTypesTable.filter(
                              (value) => value !== item.value,
                            );
                          }
                        });
                      }}
                    />
                    <ListItemText primary={item.key} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl id={'formController'}>
              <Select
                displayEmpty
                multiple
                value={NFTGradeTable}
                onChange={(event) => handleChange(event, 'grade-table')}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <div style={{ color: '#999' }}>차량 등급</div>;
                  }

                  return selected
                    .map(
                      (value) =>
                        nftGrades.find((item) => item.value === value)?.key,
                    )
                    .filter(Boolean)
                    .join(', ');
                }}
                style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{ padding: '10px', gap: 4 }}>
                  <input
                    type="checkbox"
                    checked={NFTGradeTable.length === nftGrades.length}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      setNFTGradesTable(
                        checked ? nftGrades.map((item) => item.value) : [],
                      );
                    }}
                  />
                  <ListItemText primary="전체 선택" />
                </MenuItem>
                {nftGrades.map((item) => (
                  <MenuItem
                    key={item.value}
                    value={item.value}
                    style={{ padding: '10px', gap: 4 }}
                  >
                    <input
                      type="checkbox"
                      checked={NFTGradeTable.includes(item.value)}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTGradesTable((prevNFTGradesTable) => {
                          if (checked) {
                            return [...prevNFTGradesTable, item.value];
                          } else {
                            return prevNFTGradesTable.filter(
                              (value) => value !== item.value,
                            );
                          }
                        });
                      }}
                    />
                    <ListItemText primary={item.key} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <select
              className=""
              value={vehicleSealTable}
              style={SELECT_FORM_STYLE}
              onChange={(e) => {
                setVehicleSealTable(e.target.value);
              }}
            >
              <option value="" disabled>
                인장 종류
              </option>
              {VehicleSeals.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {isLoading ? (
          <FetchLoading />
        ) : (
          tableData.slice(0, -1).map((data, index) => (
            <div key={index} style={{ padding: '10px 15px' }}>
              <div
                className="rowDiv"
                style={{
                  width: '100%',
                  height: '100%',
                  padding: 5,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      gap: 24,
                    }}
                  >
                    <DataItem
                      label="총 발행"
                      value={tableData[index + 1]?.totalIssuedCount}
                      prevValue={tableData[index]?.totalIssuedCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label="총 스펜딩"
                      value={tableData[index + 1]?.totalSpendingCount}
                      prevValue={tableData[index]?.totalSpendingCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label="홀더 평균 보유"
                      value={tableData[index + 1]?.averageHolderCount}
                      prevValue={tableData[index]?.averageHolderCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label="브리딩 생성"
                      value={tableData[index + 1]?.breedingCount}
                      prevValue={tableData[index]?.breedingCount}
                      targetDate={tableData[index + 1]?.targetDate}
                      style={{ width: '100%' }}
                    />
                  </div>

                  <div className="spaceDiv10" />
                  <div className="spaceDiv10" />

                  <div
                    style={{
                      display: 'flex',
                      gap: 24,
                    }}
                  >
                    <DataItem
                      label={`월렛 ➝ 스펜딩`}
                      value={tableData[index + 1]?.walletToSpendingCount}
                      prevValue={tableData[index]?.walletToSpendingCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label={`스펜딩 ➝ 월렛`}
                      value={tableData[index + 1]?.spendingToWalletCount}
                      prevValue={tableData[index]?.spendingToWalletCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label="이볼브 생성"
                      value={tableData[index + 1]?.evolveCount}
                      prevValue={tableData[index]?.evolveCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                      label="이볼브 소각"
                      value={tableData[index + 1]?.evolveBurnCount}
                      prevValue={tableData[index]?.evolveBurnCount}
                      targetDate={tableData[index + 1]?.targetDate}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="spaceDiv10" />

      {/*setStartAtLevel*/}



      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        레벨 분포*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <div className="spaceDiv10"/>*/}

      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAtLevel(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAtLevel}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAtLevel(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAtLevel}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeLevel === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeLevel(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeLevel === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeLevel(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      /!* <button *!/*/}
      {/*      /!*   className={`dateSelectBox ${activeDateRangeLevel === 90 ? 'active' : '' *!/*/}
      {/*      /!*   }`} *!/*/}
      {/*      /!*   onClick={() => { *!/*/}
      {/*      /!*     setActiveDateRangeLevel(90); *!/*/}
      {/*      /!*   }} *!/*/}
      {/*      /!* > *!/*/}
      {/*      /!*   3개월 *!/*/}
      {/*      /!* </button> *!/*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList('graph');*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn fit purple" onClick={() => {*/}
      {/*        handleClickDownload();*/}
      {/*      }}>*/}
      {/*        <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*/}
      {/*        엑셀 다운로드*/}
      {/*      </button>*/}

      {/*    </div>*/}
      {/*  </div>*/}

        {/*{*/}
        {/*  isLoadingGraph ? (*/}
        {/*      <div className="rowDiv" style={{*/}
        {/*        width: '100%',*/}
        {/*        height: 520,*/}
        {/*        display: 'flex',*/}
        {/*        justifyContent: 'center',*/}
        {/*        padding: 'unset'*/}
        {/*      }}>*/}
        {/*        Loading...*/}
        {/*      </div>*/}
        {/*    )*/}
        {/*    :*/}

        {/*      <div className="rowDiv" style={{*/}
        {/*      height: 520,*/}
        {/*      padding: 'unset'*/}
        {/*    }}>*/}
        {/*      <div className="descDiv" style={{*/}
        {/*        width: '100%',*/}
        {/*        height: '100%'*/}
        {/*      }}>*/}

        {/*        <SimpleComposedChart data={lineData && lineData}/>*/}

        {/*      </div>*/}
        {/*    </div>*/}

        {/*}*/}

      {/*</div>*/}

      <div className="spaceDiv10" />
      <div className="spaceDiv10" />
      <div className="spaceDiv10" />

      <div style={{ fontSize: 16, fontWeight: 'bold' }}>레벨 분포</div>

      <div className="spaceDiv10" />

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={'날짜'} />
          <SearchDateRange
              startAt={startAtLevel}
              endAt={endAtLevel}
              setStartAt={setStartAtLevel}
              setEndAt={setEndAtLevel}
          />
          <SearchBtn
              handleSearchClick={() => {
                fetchList('graph')
              }}
          />
        </SearchRow>
      </SearchContainer>

      <div className="spaceDiv10" />

      <BOTable
        schema={useSchemaMonitoringNftLevel()}
        rows={lineData}
        loading={isLoadingGraph}
        maxHeight={"25vh"}
      />

      <div className="spaceDiv10" />
      <div className="spaceDiv10" />
      <div className="spaceDiv10" />

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">차량 데이터 합산 지표</div>*/}

      {/*      <div className="right"></div>*/}
      {/*    </div>*/}
      {/*    <div className="spaceDiv10" />*/}
      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}
      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAtTotal(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAtTotal}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard" />*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAtTotal(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAtTotal}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard" />*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}
      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeTotal === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeTotal(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeTotal === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeTotal(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeTotal === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeTotal(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className={`typeSelectBox ${*/}
      {/*          tableType === 'level' ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setTableType('level');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        레벨*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${*/}
      {/*          tableType === 'stat' ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setTableType('stat');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        스탯*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className="defaultBtn"*/}
      {/*        onClick={() => {*/}
      {/*          // handleSearchClick;*/}
      {/*          fetchList('table');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className="defaultBtn fit purple"*/}
      {/*        onClick={() => {*/}
      {/*          handleClickDownload('statLevel');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        <img src={BtnIcons.downloadIcon} alt={'다운로드'} />*/}
      {/*        엑셀 다운로드*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="spaceDiv10" />

      {/*<table>*/}
      {/*  <thead>*/}
      {/*    <tr>*/}
      {/*      {tHead[tableContextType].map((i, index) => (*/}
      {/*        <th key={index} className="">*/}
      {/*          {i}*/}
      {/*        </th>*/}
      {/*      ))}*/}
      {/*    </tr>*/}
      {/*  </thead>*/}
      {/*  <tbody>*/}
      {/*    {isLoadingTable ? (*/}
      {/*      <tr>*/}
      {/*        <td*/}
      {/*          colSpan={tHead[tableContextType].length}*/}
      {/*          style={{*/}
      {/*            height: 300,*/}
      {/*            textAlign: 'center',*/}
      {/*            backgroundColor: '#FAFBFC',*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          Loading...*/}
      {/*        </td>*/}
      {/*      </tr>*/}
      {/*    ) : tBody.length > 0 ? (*/}
      {/*      tBody.map((row, index) => (*/}
      {/*        <tr*/}
      {/*          key={index}*/}
      {/*          // onClick={() => handleClickRow(row)}*/}
      {/*        >*/}
      {/*          <td className="">{row['time']}</td>*/}
      {/*          <td className="">{row['01']}</td>*/}
      {/*          <td className="">{row['10']}</td>*/}
      {/*          <td className="">{row['20']}</td>*/}
      {/*          <td className="">{row['30']}</td>*/}
      {/*          <td className="">{row['40']}</td>*/}
      {/*          <td className="">{row['50']}</td>*/}
      {/*          <td className="">{row['60']}</td>*/}
      {/*          <td className="">{row['70']}</td>*/}
      {/*          <td className="">{row['80']}</td>*/}
      {/*          <td className="">{row['90']}</td>*/}
      {/*          <td className="">{row['over']}</td>*/}
      {/*        </tr>*/}
      {/*      ))*/}
      {/*    ) : (*/}
      {/*      <tr>*/}
      {/*        <td*/}
      {/*          colSpan={tHead[tableContextType].length}*/}
      {/*          style={{*/}
      {/*            textAlign: 'center',*/}
      {/*            backgroundColor: '#FAFBFC',*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          등록된 통계 정보가 없습니다.*/}
      {/*        </td>*/}
      {/*      </tr>*/}
      {/*    )}*/}
      {/*  </tbody>*/}
      {/*</table>*/}


      <div style={{ fontSize: 16, fontWeight: 'bold' }}>
        차량 데이터 합산 지표
        {
          tableContextType === "level" ? ": 레벨" : ": 스탯"
        }
      </div>
      <div className="spaceDiv10" />

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={'날짜'} />
          <SearchDateRange
              startAt={startAtTotal}
              endAt={endAtTotal}
              setStartAt={setStartAtTotal}
              setEndAt={setEndAtTotal}
          />

          <SearchBtn
              handleSearchClick={() => {
                fetchList('table');
              }}
          />
        </SearchRow>

        <SearchRow>
          <SearchLabel text={'차량 데이터'} />
          <SearchContent>

            <button
                className={`typeSelectBox ${
                    tableType === 'level' ? 'active' : ''
                }`}
                onClick={() => {
                  setTableType('level');
                }}
            >
              레벨
            </button>
            <button
                className={`typeSelectBox ${
                    tableType === 'stat' ? 'active' : ''
                }`}
                onClick={() => {
                  setTableType('stat');
                }}
            >
              스탯
            </button>

          </SearchContent>
        </SearchRow>
      </SearchContainer>

      <div className="spaceDiv10"/>




      <BOTable
        rows={tBody}
        schema={tableContextType === "level" ? levelSchema : statSchema}
        loading={isLoadingTable}
        maxHeight={"25vh"}
      />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default car;
